<app-material>
    <div class="header" header>
        <h2>{{ 'admin.users.title' | translate }}</h2>
        <app-button *ngIf="shouldAllowUserEdit()"
                    type="primary"
                    (clicked)="openRegisterEmdUserModal()">
            {{ 'admin.users.emdRegisterModal.openButton' | translate }}
        </app-button>
    </div>
    <ng-container body>
        <app-users-table
            [users]="users"
            [userStates]="userStates"
            [userBusinessTypeFilters]="userBusinessTypeFilters"
            [isLoading]="isLoadingUsers"
            [tableConfig]="tableConfig"
            [hasTitle]="false"
            [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
            (sortChange)="onSortChange($event)"
            (filterChange)="onFilter($event)"
            (pageChange)="onPageChange($event)"
            (rowClick)="openUserDetails($event)">
        </app-users-table>
    </ng-container>
</app-material>
<app-confirmation-modal [isConfirmationInProgress]="isConfirmationInProgress"
                        (confirmEvent)="onConfirmAction()"
                        [confirmOnlyMode]="true">
</app-confirmation-modal>
<app-user-details-modal
    [canManageUsers]="shouldAllowUserEdit()"
    [userBusinessTypes]="userBusinessTypes"
    (updateUser)="onUserUpdate($event)"
    (resetUser)="openConfirmationModal($event, Action.RESET)"
    (deleteUser)="openConfirmationModal($event, Action.DELETE)">
</app-user-details-modal>
<app-register-emd-user-modal
    [employees]="emdEmployees"
    [userBusinessTypes]="emdUserBusinessTypes"
    [isRegistering]="isRegisteringEmdUser"
    (searchEmployees)="onEmdEmployeesSearch($event)"
    (register)="onRegisterEmdUser($event)">
</app-register-emd-user-modal>
